export default __webpack_public_path__ + "static/media/Pinterest-Badge-White.49084cbb.webp";